module.exports = __webpack_public_path__ + "static/media/COM_ERROR_ON.a1db212a.png";